const kr: Record<string, string> = {
  create_new_lobby: "새 로비 만들기", // FrontPage — main CTA button
  join_lobby: "로비 참가", // FrontPage — join button
  switch_language: "한국어", // FrontPage — language toggle button
  invalid_lobbyKey: "유효하지 않은 로비입니다. 예기치 않게 발생한 경우 여기에서 피드백을 제출하세요:", // Lobby — error when lobby key is invalid
  host_is_configuring: "호스트가 게임을 설정 중입니다...", // Lobby — message shown to non-host players
  start_game: "게임 시작", // Lobby — host start button
  see_all: "모든 결과 보기", // MobileResults — show all results button
  you_did_not_answer: "질문에 답하지 않았습니다", // MobileResults — shown when player didn't submit
  set_your_name: "이름 설정", // Lobby — name input prompt
  confirm: "확인", // Lobby — name confirm button
  recommendation: "실명 사용을 권장하지만 필수는 아닙니다", // Lobby — name input hint
  thanks_for_playing: "플레이해 주셔서 감사합니다", // EndPanel — end screen heading
  more_stuff: "더 많은 콘텐츠가 곧 출시됩니다", // EndPanel — end screen subheading
  knows_you_best: "당신을 가장 잘 아는 사람: <h>{{bestPlayerName}}</h>", // EndPanel — best predictor stat
  best_accuracy: "예측 정확도: <h>{{bestPlayerAccuracy}}%</h>", // EndPanel — best accuracy stat
  winner: "우승자: <h>{{winnerName}}</h>", // EndPanel — winner announcement
  winning_score: "점수: <h>{{winnerScore}}</h>", // EndPanel — winner score
  knows_you_worst: "당신을 가장 모르는 사람: <h>{{worstPlayerName}}</h>", // EndPanel — worst predictor stat
  worst_accuracy: "예측 정확도: <h>{{worstPlayerAccuracy}}%</h>", // EndPanel — worst accuracy stat
  attracted_to: "관심 있는 대상", // Lobby — player config field
  provide_info:
    "네, 게임 경험을 향상시키기 위해 추가 정보를 제공하겠습니다", // Lobby — player config opt-in
  my_age: "나이", // Lobby — player config field
  player_config: "플레이어 설정", // Lobby — player config section heading
  your_answer: "내 답변:", // MobileResults — czar answer label
  did_not_answer: "질문에 답하지 않았습니다", // MobileResults — no-answer fallback
  you_scored: "<h>{{score}}</h> 점 획득!", // MobileResults — score display with points
  calculating_error: "점수 차감 계산 중: <h>-{{score}}</h>", // MobileResults — penalty animation text
  this_is_how_answered: "{{name}}의 답변입니다", // MobileResults — other player's answer label
  lets_calculate: "예측이 얼마나 맞았는지 확인해 봅시다...", // MobileResults — transition text before scoring
  player_submissons: "플레이어 제출 답변", // MobileResults — section heading
  see_mine: "내 결과 보기", // MobileResults — toggle to own results
  start_next_round: "다음 라운드 시작", // MobileResults — host next round button
  waiting_next_round: "호스트 대기 중", // MobileResults — non-host waiting text
  explain_decision: "선택을 설명해 주시겠어요?", // MobileResults — czar explanation prompt
  czar_tier_perfect: "모든 사람이 당신을 완벽하게 예측했습니다!", // MobileResults — tier message for czar
  czar_tier_great: "사람들이 당신을 너무 잘 알고 있네요...", // MobileResults — tier message for czar
  czar_tier_good: "사람들이 당신을 꽤 잘 파악하고 있네요!", // MobileResults — tier message for czar
  czar_tier_average: "사람들의 예측이 나쁘지 않았습니다...", // MobileResults — tier message for czar
  czar_tier_bad: "사람들이 이번 예측에 애를 먹었네요", // MobileResults — tier message for czar
  czar_tier_terrible: "사람들은 당신과 정반대로 생각했습니다", // MobileResults — tier message for czar
  czar_tier_perfect_duo: "{{name}}이(가) 당신을 완벽하게 예측했습니다!", // MobileResults — tier message (2-player)
  czar_tier_great_duo: "{{name}}이(가) 당신을 너무 잘 알고 있네요...", // MobileResults — tier message (2-player)
  czar_tier_good_duo: "{{name}}이(가) 당신을 꽤 잘 파악하고 있네요!", // MobileResults — tier message (2-player)
  czar_tier_average_duo: "{{name}}의 예측이 나쁘지 않았습니다...", // MobileResults — tier message (2-player)
  czar_tier_bad_duo: "{{name}}이(가) 이번 예측에 애를 먹었네요", // MobileResults — tier message (2-player)
  czar_tier_terrible_duo: "{{name}}은(는) 당신과 정반대로 생각했습니다", // MobileResults — tier message (2-player)
  czar_nobody_answered: "아무도 예측을 제출하지 않았습니다", // MobileResults — no submissions fallback
  go_to_play: "플레이", // FrontPage — nav link
  go_to_how_to_play: "게임 방법", // FrontPage — nav link
  go_to_FAQ: "자주 묻는 질문", // FrontPage — nav link
  submit: "제출", // SubmitButton — submit button text
  waiting: "대기 중", // SubmitButton — waiting state text
  intro_for_tsar: "이번 라운드의 주인공은 <h>당신</h>입니다!", // TurnBurst — burst headline for czar
  intro_about_tsar: "이번 라운드의 주인공은 <h>{{tsar}}</h>입니다!", // TurnBurst — burst headline for others
  burst_subtitle_tsar: "솔직하게 답하세요", // TurnBurst — burst subtitle for czar
  burst_subtitle_other: "상대방의 순위를 예측하세요", // TurnBurst — burst subtitle for others
  ftl_burst_headline_tsar: "당신이 리더입니다!", // TurnBurst — FTL burst for leader
  ftl_burst_subtitle_tsar: "다른 플레이어들이 당신의 선택을 따르려 할 것입니다", // TurnBurst — FTL subtitle for leader
  ftl_burst_headline_other: "Follow the Leader \u2014 <h>{{tsar}}</h>을(를) 따라가세요!", // TurnBurst — FTL burst for followers
  ftl_burst_subtitle_other: "새 리더는 {{tsar}}입니다. 최대한 오래 따라가 보세요", // TurnBurst — FTL subtitle for followers
  ftl_still_running: "생존 중", // FtlStatusBar — alive players heading
  ftl_graveyard: "탈락자", // FtlStatusBar — eliminated players heading
  ftl_multiplier: "배율", // FtlStatusBar — multiplier label
  ftl_leader_has_chosen: "리더가 선택했습니다!", // FtlReveal — reveal phase heading
  ftl_you_survived: "살아남았습니다!", // FtlReveal — survival message
  ftl_you_were_eliminated: "탈락!", // FtlReveal — elimination message
  ftl_streak_results: "연속 결과", // FtlStreakResults — panel heading
  ftl_game_mode_label: "게임 모드", // Lobby — mode selector label
  ftl_standard: "스탠다드", // Lobby — mode option
  ftl_follow_the_leader: "Follow the Leader", // Lobby — mode option
  // ─── Reverse Round ───────────────────────────────────────
  rr_burst_headline: "모두의 의견이 중요합니다!", // TurnBurst — RR burst heading
  rr_burst_subtitle: "솔직하게 답하세요 \u2014 자신만의 방식으로 순위를 매기세요", // TurnBurst — RR burst subtitle
  rr_guess_burst_headline: "<h>리버스 라운드</h>", // TurnBurst — RR guess phase burst
  rr_guess_burst_subtitle: "이것이 누구의 선호도인지 맞혀보세요", // TurnBurst — RR guess phase subtitle
  rr_stage1_header: "솔직하게 답하세요", // ReverseRoundPanel — submission phase heading
  rr_stage2_header: "이것은 누구의 순위인가요?", // ReverseRoundPanel — guessing phase heading
  rr_high_roll_prompt: "더 높은 판돈으로 도전하고 싶으신가요?", // ReverseRoundPanel — high roll prompt
  rr_high_roll_accept: "해봐요, 한번 가즈아!", // ReverseRoundPanel — accept high roll button
  rr_high_roll_decline: "아니요, 괜찮아요", // ReverseRoundPanel — decline high roll button
  rr_not_in_group: "이 중에 없음", // ReverseRoundPanel — guess option
  rr_not_player: "{{name}} 아님", // ReverseRoundPanel — guess option
  rr_submitted_by: "{{name}}이(가) 제출", // ReverseRoundResults — sequence attribution
  rr_random_sequence: "랜덤 순서", // ReverseRoundResults — random sequence label
  rr_shown_to: "표시 대상", // ReverseRoundResults — shown-to label
  rr_guessed_correctly: "정답", // ReverseRoundResults — correct guess label
  rr_thought_it_was: "{{name}}(으)로 생각했음", // ReverseRoundResults — wrong guess label
  rr_mode_label: "리버스 라운드", // Lobby — mode selector label
  rr_mode_description: "소셜 추리 모드", // Lobby — mode selector description
  // ─── Run with the Herd ────────────────────────────────────
  herd_burst_headline: "<h>무리를 따라가라!</h>", // TurnBurst — Herd burst heading
  herd_burst_subtitle: "다수가 선택하는 것을 선택하세요 \u2014 그렇지 않으면 짓밟힙니다!", // TurnBurst — Herd burst subtitle
  herd_still_running: "생존 중", // HerdChoicePanel — alive label
  herd_trampled: "짓밟힘", // HerdChoicePanel — eliminated label
  herd_you_survived: "무리를 따라갔습니다!", // HerdChoicePanel — survival message
  herd_you_were_trampled: "짓밟혔습니다!", // HerdChoicePanel — elimination message
  herd_split: "무리가 갈라졌습니다!", // HerdStreakResults — split announcement
  herd_streak_results: "무리 결과", // HerdStreakResults — panel heading
  herd_votes: "표", // HerdStreakResults — vote count label
  herd_game_mode_label: "Run with the Herd", // Lobby — mode selector label
  // ─── Picasso ────────────────────────────────────────────────
  picasso_burst_headline: "<h>피카소 타임!</h>", // TurnBurst — Picasso burst heading
  picasso_burst_subtitle: "답을 그려보세요 \u2014 예술로 표현하세요!", // TurnBurst — Picasso burst subtitle
  picasso_gallery_burst_headline: "<h>갤러리 타임!</h>", // TurnBurst — gallery phase burst
  picasso_gallery_burst_subtitle: "이것을 누가 그렸을까요? 맞혀보세요!", // TurnBurst — gallery phase subtitle
  picasso_game_mode_label: "Picasso", // Lobby — mode selector label
  picasso_archive_which_real: "이 게임에서 그린 것은 어느 것인가요?", // PicassoImposterReveal — archive mode question
  picasso_from_another_lobby: "다른 로비에서", // PicassoImposterReveal — archive label
  picasso_imposter_accept: "수락", // PicassoCanvas — accept impersonation button
  picasso_imposter_decline: "거절", // PicassoCanvas — decline impersonation button
  picasso_impersonating: "{{name}}(으)로 위장 중", // PicassoCanvas — impersonation status text
  // ─── Homepage / Community ───────────────────────────────────
  frontpage_tagline: "서로를 알아가는 파티 게임", // FrontPage — hero tagline
  frontpage_explore_community: "커뮤니티 탐색", // FrontPage — community nav button
  frontpage_cta_title: "크리에이터가 되어보세요", // FrontPage — creator CTA heading
  frontpage_cta_subtitle: "게임에 기여하세요 \u2014 나만의 덱을 만들어보세요", // FrontPage — creator CTA subtitle
  frontpage_create_deck: "덱 만들기", // FrontPage — create deck button
  frontpage_profile: "프로필", // FrontPage — profile nav link
  frontpage_login: "로그인", // FrontPage — login button
  frontpage_logout: "로그아웃", // FrontPage — logout button
  frontpage_community: "커뮤니티", // FrontPage — community nav link
  community_title: "커뮤니티", // CommunityPage — page heading
  community_tab_gallery: "갤러리", // CommunityPage — tab label
  community_tab_analytics: "분석", // CommunityPage — tab label
  community_tab_leaderboard: "리더보드", // CommunityPage — tab label
  community_gallery_count: "{{count}}개의 그림 및 더 보기", // CommunityPage — drawing count
  community_gallery_empty: "아직 그림이 없습니다", // CommunityPage — empty state
  community_spotlight_close: "닫기", // CommunityPage — spotlight close button
  community_analytics_empty: "아직 분석 데이터가 없습니다. 먼저 게임을 플레이해 보세요!", // CommunityPage — empty state
  community_analytics_category: "카테고리", // CommunityPage — category selector label
  community_analytics_elo_title: "ELO 랭킹", // CommunityPage — ELO section heading
  community_analytics_pca_title: "의견 그룹", // CommunityPage — PCA section heading
  community_analytics_pca_subtitle: "선호도에 따른 플레이어 분포 \u2014 {{pc1}}% + {{pc2}}%의 분산 설명", // CommunityPage — PCA description
  community_analytics_welcome: "플레이어들은 이 카드를 어떻게 순위 매길까요?", // CommunityPage — welcome heading
  community_analytics_welcome_sub: "질문 및 카테고리별 ELO 랭킹과 선호도 패턴을 탐색하세요. 카테고리를 선택한 다음 질문을 선택하면 플레이어들이 답변 카드를 어떻게 순위 매겼는지 볼 수 있습니다.", // CommunityPage — welcome description
  community_insights_title: "흥미로운 발견", // CommunityPage — insights section heading
  community_insights_subtitle: "플레이어들의 순위에서 보이는 이야기들", // CommunityPage — insights description
  community_insight_divided: "대분열", // CommunityPage — insight card title
  community_insight_consensus: "만장일치", // CommunityPage — insight card title
  community_insight_chaos: "완전한 혼돈", // CommunityPage — insight card title
  community_insight_two_camps: "두 진영", // CommunityPage — insight card title
  community_insight_players: "{{count}}명의 플레이어", // CommunityPage — player count label
  community_insight_see_full: "전체 분석 보기", // CommunityPage — link to analytics
  community_decks_title: "덱으로 탐색", // CommunityPage — decks section heading
  community_decks_subtitle: "분석 데이터가 있는 덱 \u2014 클릭하여 탐색", // CommunityPage — decks section description
  community_decks_questions: "{{count}}개의 질문", // CommunityPage — question count
  community_decks_categories: "{{count}}개의 카테고리", // CommunityPage — category count
  community_deepdive_title: "심층 탐구", // CommunityPage — deep dive heading
  community_deepdive_subtitle: "모든 카테고리와 질문 탐색", // CommunityPage — deep dive description
  round: "라운드", // Timer — round counter label
  out_of: "/", // Timer — round counter separator
  wait_for_restart: "호스트의 재시작을 기다리는 중", // EndPanel — non-host waiting text
  restart_lobby: "다음 게임", // EndPanel — host restart button
  send: "전송", // FeedbackPage — send button
  feedback: "피드백:", // FeedbackPage — field label
  from: "보낸 사람:", // FeedbackPage — sender field label
  thx4Impro: "개선에 도움을 주셔서 감사합니다 :)", // FeedbackPage — thank you message
  get_back: "이제 게임으로 돌아가세요", // FeedbackPage — return prompt
  give_feedback: "피드백", // Lobby — feedback button
  quickFeedBackQuestion: "<h>당신</h>이라면 게임에서 무엇을 개선하시겠어요?", // ReportPanel — feedback question text
  quick_feedback: "빠른 피드백", // ReportPanel — feedback section heading
  skip: "건너뛰기({{remainingSkips}})", // Game — skip button with remaining count
  card_deck_specs: "질문: {{questions}}\n답변: {{answers}}\n카테고리: {{categories}}", // CardDeckBrowser — tooltip with deck stats
  card_deck_specs_questions: "질문: {{questions}}", // CardDeckBrowser — question count
  card_deck_specs_answers: "답변: {{answers}}", // CardDeckBrowser — answer count
  card_deck_specs_categories: "카테고리: {{categories}}", // CardDeckBrowser — category count
  card_deck_specs_play: "플레이", // CardDeckBrowser — singular play count
  card_deck_specs_plays: "플레이", // CardDeckBrowser — plural play count
  card_deck_specs_language: "언어: {{language}}", // CardDeckBrowser — language label
  queue_title: "대기실", // QueuePage — page heading
  queue_position_of: "대기열 위치: {{position}} / {{total}}", // QueuePage — position indicator
  queue_membership_prompt: "멤버십 코드가 있으신가요? 입력하면 대기열을 건너뛸 수 있습니다.", // QueuePage — code entry prompt
  queue_code_placeholder: "멤버십 코드", // QueuePage — code input placeholder
  queue_invalid_code: "유효하지 않은 멤버십 코드", // QueuePage — error message
  queue_submit_code: "코드 제출", // QueuePage — submit button
  queue_leave: "대기열 나가기", // QueuePage — leave button
  queue_timeout: "대기열 자리가 만료되었습니다. 다시 시도해 주세요.", // QueuePage — timeout message
  // ─── Profile / Creator Stats ───────────────────────────────
  global_rank: "글로벌 랭킹", // ProfilePage — stat label
  language_rank: "언어 랭킹", // ProfilePage — stat label
  total_plays: "총 {{count}}회 플레이", // ProfilePage — stat with count
  unique_players: "{{count}}명의 고유 플레이어", // ProfilePage — stat with count
  out_of_creators: "{{total}}명 중 #{{rank}}위", // ProfilePage — rank display
  no_play_data: "덱을 공유하여 플레이 통계를 여기에서 확인하세요", // ProfilePage — empty state
  name_taken: "이미 사용 중", // ProfilePage — username validation
  name_saved: "저장됨", // ProfilePage — save confirmation
  daily_plays_chart_title: "플레이 수", // ProfilePage — chart heading
  stats_7d: "7일", // ProfilePage — date range toggle
  stats_30d: "30일", // ProfilePage — date range toggle
  profile_dashboard: "대시보드", // ProfilePage — tab label
  profile_my_decks: "내 덱", // ProfilePage — tab label
  profile_settings: "설정", // ProfilePage — tab label
  profile_top_decks: "최고 성과 덱", // ProfilePage — section heading
  profile_search_decks: "덱 검색...", // ProfilePage — search placeholder
  profile_bio_placeholder: "짧은 소개를 작성하세요...", // ProfilePage — bio textarea placeholder
  // ─── Leaderboard & Creator Profile ─────────────────────────
  leaderboard_title: "크리에이터 리더보드", // LeaderboardPage — page heading
  leaderboard_back: "뒤로", // LeaderboardPage — back button
  leaderboard_global: "글로벌", // LeaderboardPage — tab label
  leaderboard_creator: "크리에이터", // LeaderboardPage — column header
  leaderboard_plays: "플레이 수", // LeaderboardPage — column header
  leaderboard_decks: "덱", // LeaderboardPage — column header
  leaderboard_load_more: "더 불러오기", // LeaderboardPage — pagination button
  leaderboard_empty: "크리에이터를 찾을 수 없습니다", // LeaderboardPage — empty state
  creator_not_found: "크리에이터를 찾을 수 없습니다", // CreatorProfilePage — error state
  creator_back_to_leaderboard: "리더보드로 돌아가기", // CreatorProfilePage — back button
  creator_no_decks: "이 크리에이터는 아직 덱이 없습니다", // CreatorProfilePage — empty state
  creator_decks_title: "{{count}}개의 덱", // CreatorProfilePage — section heading
  explainer_default: "각 색상 = 하나의 순위", // ExplainerOverlay — default color legend
  explainer_high: "높은 평가 \u00b7 자주 1위에 순위됨", // ExplainerOverlay — high rank legend
  explainer_low: "낮은 평가 \u00b7 자주 5위에 순위됨", // ExplainerOverlay — low rank legend
  // ─── Friend Pool ─────────────────────────────────────────────
  friend_pool_title: "서로에 대한 질문", // Lobby — friend pool section heading
  friend_pool_add_placeholder: "친구 추가", // FriendPoolEditor — add friend input placeholder
  friend_pool_login_hint: "로그인하면 친구 그룹을 저장할 수 있습니다", // FriendPoolEditor — login prompt

  // ─── Old Lobby Config (GameConfigPanel) ────────────────────────
  game_config: "게임 설정", // GameConfigPanel — section heading
  game_mode: "게임 모드:", // GameConfigPanel — mode label
  speed: "속도:", // GameConfigPanel — speed label
  rounds: "라운드:", // GameConfigPanel — rounds label
  family_friendly: "가족 친화적", // GameConfigPanel — mode option
  party: "일반", // GameConfigPanel — mode option
  slow: "느리게 (권장)", // GameConfigPanel — speed option
  medium: "보통", // GameConfigPanel — speed option
  fast: "빠르게", // GameConfigPanel — speed option
  one_round: "1", // GameConfigPanel — round option
  two_rounds: "2", // GameConfigPanel — round option
  three_rounds: "3 (권장)", // GameConfigPanel — round option
  five_rounds: "5", // GameConfigPanel — round option

  // ─── FAQ / Bela ────────────────────────────────────────────────
  honorable_mention: "Honorable Mention", // FAQ — bela section heading
  bela_thanks:
    "I want to sincerly thank my friend Bela, who mentored this code project in his freetime and helped me with his expertise in programming, deployment and networking.", // FAQ — bela tribute text
  secret_admirer: "A secret admirer", // FeedbackPage — anonymous sender placeholder

  // ─── Bela Quotes (BelaQuote) ───────────────────────────────────
  bela_q_1: "Erweiterbarkeit, dies das",
  bela_q_2: "Das ist ja auch nicht schwer",
  bela_q_3: "Das wird dir beim deployment vermutlich um die ohren fliegen.",
  bela_q_4: "Ich würde ja rust empfehlen, aber du willst ja noch vor weihnachten fertig werden.",
  bela_q_5: "Ich würde immer noch das Backend abfackeln und neu bauen.",
  bela_q_6: "Du bist wie gesagt fernab von den Situationen, für die das designed wurde.",
  bela_q_7:
    "Mach dir halt keine Gedanken um Skalierung, wenn du keine Probleme mit Skalierung hast.",
  bela_q_8:
    "Ja, das ist halt ehrlich gesagt gerade die falsche Metrik.\nDas Ding wird umfallen, bei mehr Benutzern, dafür musst du es nicht testen.",
  bela_q_9: "Ja also das ist bescheidenes design",
  bela_q_10:
    "Das funktioniert super, solange du nur mit einer datenbank kommunizierst\naber genau in deinem fall bricht es halt auseinander",

  // ─── Deck Tutorial (DeckTutorial.tsx) ──────────────────────────
  deck_tutorial_hero_title: "How to Create a Card Deck",
  deck_tutorial_hero_subtitle: "Everything you need to know to build your own deck. It's easier than you think, and if formatting feels tricky, AI can do it for you.",
  deck_tutorial_what_is_deck: "What is a Deck?",
  deck_tutorial_what_is_deck_body: "A deck is a collection of questions and answers organized into categories. Categories group thematically related content together. When a turn starts, the game picks a category, then picks a question and 5 answers from it.",
  deck_tutorial_hierarchy_example: "Example structure:",
  deck_tutorial_min_cards_rule: "For the Standard game mode, each category needs at least 1 question and 5 answer cards to be playable. Other game modes like Picasso have different requirements (see below).",
  deck_tutorial_questions_title: "How Questions Work: The Two Sides",
  deck_tutorial_questions_body: "Every question has two versions: one addressed to \"you\" (for the tsar) and one using the tsar's name (for everyone else).",
  deck_tutorial_questions_why: "The tsar reads \"What would you do?\" while everyone else reads \"What would Sarah do?\" — so players can focus on predicting instead of rephrasing.",
  deck_tutorial_refresh_tsar: "Click to see how it looks with different tsar names",
  deck_tutorial_formatting_title: "Formatting: Highlights and the Tsar Name",
  deck_tutorial_formatting_body: "Two special formatting tools let you make cards look great in-game:",
  deck_tutorial_formatting_tip: "The editor has \"insert tsar name\" and \"highlight selection\" buttons that do this formatting for you. No need to type the tags manually.",
  deck_tutorial_ai_title: "Too Complicated? Let AI Do It.",
  deck_tutorial_ai_body: "Just type your question in plain text, something like \"what food would you never eat\", and press the magic wand button. AI will generate both the \"for the tsar\" and \"about the tsar\" versions with proper formatting. Works in any language!",
  deck_tutorial_ai_tip: "You can always edit the AI's output if you want to tweak it.",
  deck_tutorial_answers_title: "Answer Cards",
  deck_tutorial_answers_body: "Answer cards are simpler: just text, no special formatting needed. They're the options the tsar ranks. 5 answer cards from the same category are shown each turn. Keep them short and punchy.",
  deck_tutorial_friend_token_title: "Friend Names in Answer Cards",
  deck_tutorial_friend_token_body: "Want answer cards that use your friends' names? Use the {{friend}} token. At game time, it gets replaced with actual names from the player list. This lets you create personal, social questions without having to hardcode anyone's name.",
  deck_tutorial_friend_token_example_header: "How it works:",
  deck_tutorial_friend_token_example_card: "You write an answer card: {{friend}}",
  deck_tutorial_friend_token_example_resolve: "In-game, 5 copies appear — each showing a different player's name (e.g. Sarah, Max, Jordan, Alex, Riley)",
  deck_tutorial_friend_token_no_duplicate_title: "You only need to add it once!",
  deck_tutorial_friend_token_no_duplicate_body: "A single {{friend}} card automatically produces multiple unique answer cards at game time — one per friend. You don't need to add the same card twice. The game handles the duplication for you.",
  deck_tutorial_friend_token_button_tip: "Use the \"insert friend name\" button in the answer card editor to insert the {{friend}} token at the cursor position. The preview will show it with a random name so you can see how it looks.",
  deck_tutorial_skip_to_answers: "Skip to answer cards",
  deck_tutorial_nav_questions: "How to write questions",
  deck_tutorial_nav_answers: "How to write answers",
  deck_tutorial_nav_friend: "How to write questions about my friends",
  deck_tutorial_categories_title: "Categories: Grouping It All Together",
  deck_tutorial_categories_body: "Categories are tags that connect questions and answers. When a turn starts, the game picks a category, then picks a question and 5 answers from that category. That's why you need at least 5 answer cards per category for Standard mode.",
  deck_tutorial_categories_tip: "Make categories thematic (e.g., \"food\", \"relationships\", \"hypotheticals\"). This keeps the game coherent.",
  deck_tutorial_reuse_title: "Reusing cards across categories",
  deck_tutorial_reuse_body: "Here's a powerful feature: the same card can belong to multiple categories at once. When you assign categories to a card, you're not putting it in a box. You're tagging it. One answer card like \"Pizza\" could appear in a \"food\" category, a \"guilty pleasures\" category, and a \"first date\" category. Same card, different contexts.",
  deck_tutorial_reuse_example_header: "Example: one card, many categories",
  deck_tutorial_reuse_benefit: "This means you don't have to create the same card twice. Write it once, tag it with all the categories where it fits, and the game will use it in each of those contexts. The more categories a card belongs to, the more versatile your deck becomes.",
  deck_tutorial_picasso_title: "Bonus Mode: Picasso",
  deck_tutorial_picasso_body: "Picasso is a special bonus mode that the game triggers during a match. Instead of ranking pre-made answer cards, players draw their answers. Not every question works well as a drawing prompt, so you can mark individual questions as \"Picasso compatible\" when creating them.",
  deck_tutorial_picasso_checkbox: "\"Picasso compatible\" checkbox",
  deck_tutorial_picasso_checkbox_body: "When creating a question card, you'll see a checkbox labeled \"Picasso compatible\". Check this if the question works well as a drawing prompt. The game uses this to decide which questions can appear during Picasso rounds.",
  deck_tutorial_picasso_good_title: "Good Picasso questions (visual, creative, personal):",
  deck_tutorial_picasso_good_why: "These invite expressive, personal drawings where every player's answer will look completely different. That's what makes Picasso fun.",
  deck_tutorial_picasso_bad_title: "Bad Picasso questions (abstract, no drawing value):",
  deck_tutorial_picasso_bad_why: "\"What do you value most in a friend?\" is too abstract to draw. And \"What's your favorite ice cream flavor?\" has no real drawing value. Drawing a bowl of vanilla ice cream tells you no more than just writing the word \"vanilla\". Good Picasso questions should allow for expressive, unique answers that are genuinely more interesting as drawings than as text.",
  deck_tutorial_picasso_versatile_title: "Versatile questions work everywhere",
  deck_tutorial_picasso_versatile_body: "Some questions work great in both Standard and Picasso mode. For example, \"What does your happy place look like?\" can be answered by drawing it OR by ranking a list of options like Beach, Mountains, Home, Library, Park. If you write a question like this, check the Picasso box and also make sure the category has enough answer cards for Standard mode. That way the question gets used in both modes.",
  deck_tutorial_picasso_no_answers: "Picasso-only questions don't need answer cards. If a category only has Picasso-compatible questions and no answer cards, it will only appear during Picasso rounds. The game handles this automatically.",
  deck_tutorial_preview_title: "Preview & Polish",
  deck_tutorial_preview_body: "You can preview any card by clicking the Preview button. The preview shows exactly how the card will look in-game. Click the refresh icon to see it with different tsar names. Before leaving the editor, it warns you about incomplete categories.",
  deck_tutorial_cta_title: "Ready to create?",
  deck_tutorial_cta_button: "Go to My Profile",
  deck_tutorial_back_to_howto: "Back to How to Play",

  // ═══════════════════════════════════════════════════════════════
  // NEW KEYS — added for i18n coverage
  // ═══════════════════════════════════════════════════════════════

  // ─── Generic / shared ──────────────────────────────────────────
  back: "뒤로", // FeedbackPage, CardDeckBrowser — back button
  cancel: "취소", // CardDeckViewer — cancel button in report dialog
  close: "닫기", // CardDeckViewer — close button
  continue: "계속", // FtlStreakResults, HerdStreakResults, PicassoResults — host continue button
  accept: "수락", // PicassoCanvas — accept button
  decline: "거절", // PicassoCanvas — decline button
  dismiss: "닫기", // AdminMessageDialog, ShutdownDialog — dismiss button
  done: "완료", // CreateDeckConfigMenu — done button
  lock_in: "확정", // SequenceBar — submit ranking button
  ready: "준비 완료", // MobileResults, FtlStreakResults, HerdStreakResults, PicassoResults — ready toggle
  unready: "준비 취소", // EndPanel, MobileResults, FtlStreakResults, HerdStreakResults, PicassoResults — unready toggle
  report: "신고", // CardDeckViewer — report button
  submitted: "제출됨", // PicassoCanvas — submission status
  waiting_for_host: "호스트를 기다리는 중...", // FtlStreakResults, HerdStreakResults, PicassoResults — non-host waiting
  waiting_for_others: "다른 플레이어를 기다리는 중...", // PicassoImposterReveal, ReverseRoundPanel — waiting message
  select_all: "전체 선택", // CardDeckBrowser, TopicSelector — bulk select
  deselect_all: "전체 선택 해제", // CardDeckBrowser, TopicSelector — bulk deselect

  // ─── End Panel ─────────────────────────────────────────────────
  end_panel_review_game: "전체 게임 복습", // EndPanel — review game button
  end_panel_play_again: "다시 플레이", // EndPanel — play again button

  // ─── FTL extras ────────────────────────────────────────────────
  ftl_leader: "리더:", // FtlStreakResults — leader label

  // ─── Herd extras ───────────────────────────────────────────────
  herd_results: "무리 결과", // HerdStreakResults — panel heading
  herd_trampled_spectating: "짓밟혔습니다. 관전 중...", // HerdChoicePanel — spectating message
  herd_pick_majority: "다수가 선택하는 것을 선택하세요!", // HerdChoicePanel — instruction text
  herd_locked_in: "확정됨. 다시 탭하면 변경 가능...", // HerdChoicePanel — lock-in confirmation

  // ─── Picasso extras ────────────────────────────────────────────
  picasso_impersonate_prompt: "쉿! 위장할 수 있나요", // PicassoCanvas — impersonation modal text
  picasso_eraser: "지우개", // PicassoCanvas — eraser button
  picasso_unsubmit: "제출 취소", // PicassoCanvas — unsubmit button
  picasso_submit_drawing: "그림 제출", // PicassoCanvas — submit drawing button
  picasso_which_true_answer: "진짜 답은 누구의 것인가요", // PicassoImposterReveal — question heading
  picasso_confirm_vote: "투표 확정", // PicassoImposterReveal — confirm vote button
  picasso_gallery: "갤러리", // PicassoResults — gallery section heading
  picasso_impersonated: "위장됨", // PicassoResults — impersonation badge
  picasso_challenges: "챌린지", // PicassoResults — challenges section heading

  // ─── Reverse Round extras ──────────────────────────────────────
  rr_whose_ranking: "이것은 누구의 순위인가요?", // ReverseRoundPanel — guess phase question
  rr_high_stakes_prompt: "더 높은 판돈으로 도전하고 싶으신가요?", // ReverseRoundPanel — high roll prompt
  rr_roll_it: "해봐요, 한번 가즈아!", // ReverseRoundPanel — accept high roll
  rr_nah: "아니요, 괜찮아요", // ReverseRoundPanel — decline high roll

  // ─── Deck Browser ──────────────────────────────────────────────
  deck_browser_random: "랜덤", // CardDeckBrowser — random deck button
  deck_browser_deck: "덱", // CardDeckBrowser — search mode toggle
  deck_browser_creator: "크리에이터", // CardDeckBrowser — search mode toggle
  deck_browser_languages: "언어", // CardDeckBrowser — language filter label
  deck_browser_create_deck: "덱 만들기", // CardDeckBrowser — create deck button
  deck_browser_max_decks: "최대 30개의 덱 선택 가능", // CardDeckBrowser — max selection warning

  // ─── Deck Viewer ───────────────────────────────────────────────
  deck_viewer_created_by: "제작자", // CardDeckViewer — creator label
  deck_viewer_questions: "질문", // CardDeckViewer — tab label
  deck_viewer_answers: "답변", // CardDeckViewer — tab label
  deck_viewer_for_tsar: "본인 시점", // CardDeckViewer — sub-tab label
  deck_viewer_about_tsar: "타인 시점", // CardDeckViewer — sub-tab label
  deck_viewer_report_deck: "덱 신고", // CardDeckViewer — report dialog title
  deck_viewer_report_why: "이 덱을 신고하는 이유는 무엇인가요?", // CardDeckViewer — report dialog prompt
  deck_viewer_report_reason: "이유", // CardDeckViewer — report reason label
  deck_viewer_report_offensive: "불쾌한 내용", // CardDeckViewer — report reason option
  deck_viewer_report_inappropriate: "부적절한 내용", // CardDeckViewer — report reason option
  deck_viewer_report_spam: "스팸", // CardDeckViewer — report reason option
  deck_viewer_report_low_quality: "낮은 품질", // CardDeckViewer — report reason option
  deck_viewer_report_details: "추가 세부 사항 (선택)", // CardDeckViewer — report details field label
  deck_viewer_submit_report: "신고 제출", // CardDeckViewer — submit report button

  leave: "나가기", // Lobby — leave button

  // ─── Lobby UI ──────────────────────────────────────────────────
  lobby_players: "플레이어", // Lobby — players panel heading
  lobby_invite: "초대", // Lobby — invite button
  lobby_copied: "복사됨!", // Lobby — invite button after copy
  lobby_by_topics: "주제별", // Lobby — deck selection mode toggle
  lobby_pick_decks: "덱 선택", // Lobby — deck selection mode toggle

  // ─── Lobby Tabs ────────────────────────────────────────────────
  lobby_tab_presets: "프리셋", // Lobby — right panel tab
  lobby_tab_questions: "질문", // Lobby — right panel tab
  lobby_tab_custom: "커스텀", // Lobby — right panel tab

  // ─── Lobby Presets ─────────────────────────────────────────────
  lobby_preset_party: "파티", // LobbyPresetSelector — preset name
  lobby_preset_party_desc: "모든 게임 모드, 잘 균형 잡힌 설정.", // LobbyPresetSelector — preset description
  lobby_preset_bonanza: "보난자", // LobbyPresetSelector — preset name
  lobby_preset_bonanza_desc: "8명 이상. 모든 사람이 계속 액션에 참여합니다.", // LobbyPresetSelector — preset description
  lobby_preset_duet: "듀엣", // LobbyPresetSelector — preset name
  lobby_preset_duet_desc: "서로를 얼마나 잘 알고 있는지 알아보세요.", // LobbyPresetSelector — preset description
  lobby_preset_picasso: "Picasso", // LobbyPresetSelector — preset name
  lobby_preset_picasso_desc: "그림 그리기 모드 올인!", // LobbyPresetSelector — preset description

  // ─── Friend Pool extras ────────────────────────────────────────
  friend_pool_players: "플레이어 (자동 포함)", // FriendPoolEditor — auto-included players label
  friend_pool_extra: "추가 친구", // FriendPoolEditor — custom friends label

  // ─── Create Deck Config ────────────────────────────────────────
  config_link_created: "\u2713 링크가 생성되었습니다!", // CreateDeckConfigMenu — success message
  config_create_link_subtitle: "이 덱들을 위한 공유 링크 만들기", // CreateDeckConfigMenu — subtitle
  config_your_name: "내 이름", // CreateDeckConfigMenu — name field label
  config_name_placeholder: "예: 지민", // CreateDeckConfigMenu — name placeholder
  config_config_name: "설정 이름", // CreateDeckConfigMenu — config name field label
  config_config_placeholder: "예: 파티 나이트", // CreateDeckConfigMenu — config name placeholder
  config_error_name: "설정 이름을 입력해 주세요", // CreateDeckConfigMenu — validation error
  config_error_your_name: "이름을 입력해 주세요", // CreateDeckConfigMenu — validation error
  config_error_failed: "설정 생성에 실패했습니다", // CreateDeckConfigMenu — API error
  config_create_link: "링크 만들기", // CreateDeckConfigMenu — create button

  // ─── Config Preview ────────────────────────────────────────────
  config_preview_not_found: "설정을 찾을 수 없습니다", // ConfigPreviewPage — error
  config_preview_load_failed: "설정을 불러오지 못했습니다", // ConfigPreviewPage — error
  config_preview_lobby_failed: "로비 생성에 실패했습니다", // ConfigPreviewPage — error
  config_preview_game_failed: "게임 시작에 실패했습니다", // ConfigPreviewPage — error
  config_preview_invite_text: "님이 특별한 rank.io 버전을 플레이하도록 초대했습니다", // ConfigPreviewPage — invite description
  config_preview_play_count: "명이 플레이했습니다", // ConfigPreviewPage — play count label
  config_preview_decks_included: "포함된 덱:", // ConfigPreviewPage — section heading
  config_preview_and_more: "외 {{count}}개", // ConfigPreviewPage — overflow text
  config_preview_creating: "로비 생성 중...", // ConfigPreviewPage — loading button text
  config_preview_play: "이 덱으로 플레이", // ConfigPreviewPage — play button text

  // ─── Topics ────────────────────────────────────────────────────
  topic_self_identity: "자아와 정체성", // TopicSelector via topics.ts — topic filter label
  topic_values_meaning: "가치관과 의미", // TopicSelector via topics.ts — topic filter label
  topic_life_stories: "인생 이야기", // TopicSelector via topics.ts — topic filter label
  topic_hypotheticals: "가정 상황", // TopicSelector via topics.ts — topic filter label
  topic_love_relationships: "사랑과 관계", // TopicSelector via topics.ts — topic filter label
  topic_sex_intimacy: "성과 친밀감", // TopicSelector via topics.ts — topic filter label
  topic_social_friends: "사교와 친구", // TopicSelector via topics.ts — topic filter label
  topic_awkward_cringe: "어색하고 민망한 순간", // TopicSelector via topics.ts — topic filter label
  topic_food_drink: "음식과 음료", // TopicSelector via topics.ts — topic filter label
  topic_sports_fitness: "스포츠와 피트니스", // TopicSelector via topics.ts — topic filter label
  topic_music: "음악", // TopicSelector via topics.ts — topic filter label
  topic_movies_tv_culture: "영화, TV와 문화", // TopicSelector via topics.ts — topic filter label
  topic_lifestyle_style: "라이프스타일과 스타일", // TopicSelector via topics.ts — topic filter label
  topic_philosophy_ethics: "철학과 윤리", // TopicSelector via topics.ts — topic filter label
  topic_dark_uncomfortable: "어둡고 불편한 주제", // TopicSelector via topics.ts — topic filter label
  topic_politics_society: "정치와 사회", // TopicSelector via topics.ts — topic filter label
  topic_career_ambition: "커리어와 야망", // TopicSelector via topics.ts — topic filter label
  topic_games_gaming: "게임", // TopicSelector via topics.ts — topic filter label
  topic_humor_absurd: "유머와 부조리", // TopicSelector via topics.ts — topic filter label
  topic_travel_places: "여행과 장소", // TopicSelector via topics.ts — topic filter label
  topic_rank_friends: "친구 순위 정하기", // TopicSelector via topics.ts — topic filter label
  topic_rank_friends_needs_pool: "친구 목록을 켜고 이름을 추가하세요. 이 주제는 목록에 있는 사람들의 순위를 정합니다.", // TopicSelector — shown when the friends topic is picked but the friend pool is off
  topic_18_plus: "18+", // TopicSelector via topics.ts — topic filter label
  topic_low_quality: "낮은 품질", // TopicSelector via topics.ts — topic filter label

  // ─── Card Creator ──────────────────────────────────────────────
  card_creator_question: "질문", // CardCreationWidget — card creation form
  card_creator_answer: "답변", // CardCreationWidget — card creation form
  card_creator_for_tsar: "본인 시점", // CardCreationWidget — card creation form
  card_creator_about_tsar: "타인 시점", // CardCreationWidget — card creation form
  card_creator_card_text: "카드 텍스트", // CardCreationWidget — card creation form
  card_creator_tsar_tooltip: "차르는 해당 라운드의 주인공입니다.", // CardCreationWidget — card creation form
  card_creator_insert: "삽입", // CardCreationWidget — card creation form
  card_creator_tsar_name: "차르 이름", // CardCreationWidget — card creation form
  card_creator_highlight_tooltip: "차르의 대명사를 강조 표시하는 데 사용합니다.", // CardCreationWidget — card creation form
  card_creator_highlight_selection: "선택 항목\n강조 표시", // CardCreationWidget — card creation form
  card_creator_friend_tooltip: "{{friend}} 토큰을 삽입합니다. 게임 중에 플레이어/친구 이름으로 대체됩니다.", // CardCreationWidget — card creation form
  card_creator_friend_name: "친구 이름", // CardCreationWidget — card creation form
  card_creator_ai_tooltip: "AI로 형식 지정 \u2014 '본인 시점'과 '타인 시점' 두 버전 자동 생성", // CardCreationWidget — card creation form
  card_creator_format_ai: "AI로 형식 지정", // CardCreationWidget — card creation form
  card_creator_formatting: "형식 지정 중...", // CardCreationWidget — card creation form
  card_creator_preview: "미리보기", // CardCreationWidget — card creation form
  card_creator_categories: "카테고리", // CardCreationWidget — card creation form
  card_creator_new_category: "새 카테고리", // CardCreationWidget — card creation form
  card_creator_probability: "확률:", // CardCreationWidget — card creation form
  card_creator_picasso_compatible: "Picasso 호환", // CardCreationWidget — card creation form
  card_creator_add_card: "카드 추가", // CardCreationWidget — card creation form
  card_creator_warn_highlight_title: "답변 카드의 텍스트를 강조 표시할 수 없습니다", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_highlight_desc: "강조 표시는 질문 카드에서만 사용해야 하며, 차르의 이름과 대명사를 강조 표시하기 위한 것입니다.", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_tsar_answer_title: "답변에 차르 이름을 삽입하시겠습니까?", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_tsar_answer_desc: "답변 카드에 차르의 이름을 삽입하는 것은 관례에 어긋나며 특수한 경우에만 사용해야 합니다. 일반적으로 답변 카드의 정보는 차르의 이름을 참조할 필요가 없습니다.", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_empty_for_title: "'본인 시점' 영역의 텍스트가 비어 있습니다", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_empty_for_desc: "질문 카드 텍스트는 양쪽 모두 비울 수 없습니다.", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_empty_answer_title: "'답변' 영역의 텍스트가 비어 있습니다", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_empty_answer_desc: "답변 카드 텍스트는 비울 수 없습니다.", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_no_categories_title: "카테고리가 선택되지 않았습니다", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_no_categories_desc: "카드에는 적어도 하나의 카테고리 태그가 필요합니다.", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_duplicate_friend_title: "{{friend}} 카드 중복", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_duplicate_friend_desc: "이 카테고리에 이미 {{friend}} 카드가 있습니다. 하나의 {{friend}} 카드는 라운드마다 자동으로 다른 친구 이름으로 대체됩니다 \u2014 두 번 추가할 필요가 없습니다.", // CardCreationWidget — warning props for CardWarning
  card_creator_add_anyway: "그래도 추가", // CardCreationWidget — card creation form
  card_creator_needs_formatting_title: "질문에 형식 지정이 필요합니다", // CardCreationWidget — warning props for CardWarning
  card_creator_needs_formatting_about: "'타인 시점' 버전이 없습니다. AI로 자동 완성하고 형식을 지정하시겠습니까?", // CardCreationWidget — warning props for CardWarning
  card_creator_needs_formatting_general: "질문에 형식이 없는 것 같습니다 \u2014 강조된 대명사나 {{tsar}} 태그가 없습니다. AI로 형식을 지정하시겠습니까?", // CardCreationWidget — warning props for CardWarning

  // ─── Card Warning ──────────────────────────────────────────────
  card_warning_do_not_show: "다시 표시하지 않기", // CardWarning — suppress checkbox
  card_warning_go_back: "뒤로", // CardWarning — back button
  card_warning_enable_anyway: "그래도 활성화", // CardWarning — override button

  // ─── Admin Message Dialog ──────────────────────────────────────
  admin_message_title: "관리자 메시지", // AdminMessageDialog — dialog title
  admin_message_reply_placeholder: "관리자에게 답장...", // AdminMessageDialog — reply input placeholder
  admin_message_reply_sent: "답장이 전송되었습니다!", // AdminMessageDialog — success message

  // ─── Shutdown Dialog ───────────────────────────────────────────
  shutdown_now: "지금", // ShutdownDialog — countdown final text
  shutdown_title: "예정된 유지 관리", // ShutdownDialog — dialog title
  shutdown_message_placeholder: "관리자에게 메시지 남기기...", // ShutdownDialog — message input placeholder
  shutdown_message_sent: "메시지가 전송되었습니다!", // ShutdownDialog — success message

  // ─── Report Panel ──────────────────────────────────────────────
  report_panel_title: "카드 평가 / 신고", // ReportPanel — panel heading

  // ─── Preview Card ──────────────────────────────────────────────
  preview_card_probability: "확률: ", // PreviewCard — probability tooltip prefix

  // ─── Join Page ─────────────────────────────────────────────────
  join_name: "이름", // JoinPage — name field label
  join_exit: "나가기", // JoinPage — exit button

  // ─── Teasers ───────────────────────────────────────────────────
  leaderboard_teaser_title: "최고 크리에이터", // LeaderboardTeaser — section heading
  leaderboard_teaser_plays: "플레이", // LeaderboardTeaser — play count unit
  leaderboard_teaser_empty: "크리에이터 리더보드", // LeaderboardTeaser — empty state
  leaderboard_teaser_full: "전체 리더보드", // LeaderboardTeaser — full leaderboard link
  analytics_teaser_title: "트렌드", // AnalyticsTeaser — section heading
  analytics_teaser_desc: "ELO와 플레이어 그룹 분석", // AnalyticsTeaser — description
  analytics_teaser_explore: "분석 탐색", // AnalyticsTeaser — explore button
  gallery_teaser_title: "갤러리", // GalleryTeaser — section heading
  gallery_teaser_desc: "플레이어 그림 보기", // GalleryTeaser — description
  gallery_teaser_explore: "갤러리 탐색", // GalleryTeaser — explore button
};

export default kr;
